import React from 'react'
//import { useState } from 'react'
import './styles/DayPicker.css'

const DayPicker = () => {

    // const [daysSelected, setDaysSelected] = useState({
    //     M: false,
    //     T: false,
    //     W: false,
    //     Th: false,
    //     F: false,
    //     Sat: false,
    //     Sun: false,
    //     // Etc. you get the point. Once you get it working in here.
    //     // You move the state to the EditTaskForm, and pass it as a prop.
    // })

    // const retoggle = () => {setDaysSelected()} // This isn't exactly right...


    
    // Helper function that utilizes setDaysSelected
    // Takes in the day, and toggles it on or off.
    

    return (
        <div className="buttonwrap">
            <button className="rbtn"> M </button>
            <button className="rbtn" id='rbtn2'> T </button>
            <button className="rbtn" id='rbtn3'> W </button>
            <button className="rbtn" id='rbtn4'> Th </button>
            <button className="rbtn" id='rbtn5'> F </button>
            <button className="rbtn" id='rbtn6'> Sa </button>
            <button className="rbtn" id='rbtn7'> S </button>
        </div>
    )
}

export default DayPicker
